export default __webpack_public_path__ + "static/media/profile_pic.8461cc16.jpg";